'use client'
import Link from 'next/link'

import { clsx } from 'clsx'

import { FC, Fragment } from 'react'

import { MessengersComponent } from '@/app/shared/components/messengers'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import useLayout from '@/app/shared/store/layout.store'

// interface
interface ISiteInfo extends IClassName {
  classNameIcon?: string
  modal?: boolean
}

// component
const SiteInfoComponent: FC<Readonly<ISiteInfo>> = ({ className, classNameIcon, modal }) => {
  const email = useLayout((state) => state.email)
  const phones = useLayout((state) => state.phones)
  const year = new Date().getFullYear()

  // return
  return (
    <div
      className={clsx(
        'flex flex-wrap items-center tablet:gap-12',
        className,
        { 'max-tablet:gap-4': modal },
        { 'max-tablet:gap-[38px]': !modal },
      )}
    >
      <MessengersComponent
        className={clsx('row-[2] text-content1-200', classNameIcon)}
        modal={modal}
      />
      <span
        className={clsx({
          'grid font-semibold laptop:text-base': modal,
          'flex text-base font-semibold max-laptop:m-auto max-tablet:items-center max-tablet:gap-2 tablet:flex-col':
            !modal,
        })}
      >
        <span>Email:</span>
        <Link
          href={`mailto:${email?.value}`}
          target={'_blank'}
          className={clsx('transition-colors', {
            'hover:text-primary': !modal,
            'hover:text-success': modal,
          })}
        >
          {email?.value}
        </Link>
      </span>

      {!modal ? (
        <Fragment>
          <ul className={'flex flex-col text-base font-semibold'}>
            {phones.map((item, index: number) => (
              <li key={index}>
                <Link
                  href={`tel:${item?.value?.replace(/\D/g, '')}`}
                  className={'font-semibold outline-0 transition'}
                >
                  {item?.value}
                </Link>
              </li>
            ))}
          </ul>

          <span
            className={
              'w-full whitespace-nowrap text-[14px] uppercase max-tablet:text-center tablet:self-end tablet:text-right laptop:mt-0 laptop:w-fit laptop:-translate-y-[9px] large:translate-y-0 large:self-center'
            }
          >
            © English Prime, 2005-{year}
          </span>
        </Fragment>
      ) : null}
    </div>
  )
}

export default SiteInfoComponent
